import './facility.css'
import React from 'react';
import bed from '../pictures/bed.png'
import house from '../pictures/house-size.png'
import key from '../pictures/key.png'
function Facility() {
    return (
        <div className="flex">
            <div className="bed">
                <img src={bed} alt="" />
                <div className="apart">Apartments</div>
                <div className="add1">1, 2 & 3 Bedroom</div>
                <div className="line"></div>
            </div>
            <div className="house">
                <img src={house} alt="" />
                <div className="size">Size</div>
                <div className="add2">900 to 3400 Sq Ft.</div>
                <div className="line1"></div>
            </div>
            <div className="key">
                <img src={key} alt="" />
                <div className="hand">Hanover</div>
                <div className="add3">Ready to Move in</div>
                <div className="line2"></div>
            </div>
            <div className="last">
                <div className="start">Starting price</div>
                <div className="price">₹70,50500</div>
            </div>
        </div>
    );

}

export default Facility